enum Mutation {
  SET_BREAKS = 'setBreaks',
  SET_INITIAL = 'setInitial',
  ADD_DELETED_BREAK_ID = 'addDeletedBreakId',
  SET_CREATE_ID_COUNTER = 'setCreateIdCounter',
}

export default Mutation;
